import React, { Fragment } from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import GratuityNominees from "./Nominees/Nominees";
import {
  getGenderName,
  getMaritalName,
  getFormattedDate,
  getAddressAsString,
  getFullName
} from "../../../util/helpers";
import { getFatherOrMotherOrSpouseName } from "../../../util/onBoardingDataFilters";
import { ADDRESS_TYPES } from "../../../constants/constants";

const EPFForm2 = ({
  genders,
  maritalStatusList,
  personalDetails,
  relationShipList,
  states,
  updatePersonalDetails,
  addEPFFrom2Details,
  deleteEPFFrom2Details,
  updateNomineeDetails
}) => {
  const {
    addresses,
    dateofJoining,
    gratuityIsFatherOrMotherOrSpouse,
    familyMembers,
    ePFNomineeDetails
  } = personalDetails;

  const fullName = getFullName(personalDetails);

  const handleOnChangePersonalDetails = ({ target: { name, value } }) => {
    updatePersonalDetails(name, value);
  };
  const handleOnChangeGratuityDetails = (
    { target: { name, value } },
    memberId
  ) => {
    updateNomineeDetails(
      name,
      value.trimStart(),
      "ePFNomineeDetails",
      memberId
    );
  };
  const handleOnSelectedNominee = memberId => {
    const newNominee = {
      familyMemberId: memberId,
      ePFSharePercentage: "",
      guradianName: "",
      guardianAddress: "",
      candidateId: personalDetails.id
    };
    addEPFFrom2Details(newNominee);
  };

  const handleOnDeleteNominee = deletedNomineeId => {
    deleteEPFFrom2Details(deletedNomineeId);
  };

  return (
    <Fragment>
      <Card>
        <Card.Header className="text-center">FORM-2 (Revised)</Card.Header>
        <Card.Body>
          <div className="text-center">
            <h6>
              NOMINATION AND DECLARATION FORM FOR UNEXEMPTED/ EXEMPTED
              ESTABLISHMENT
            </h6>
            <h6>
              {" "}
              Declaration and Nomination Form under the Employee Provident Funds
              & Employee Pension Scheme
            </h6>
            <p>
              (Paragraph 33 & 61 (1) of the Employee Provident Fund Scheme, 1952
              & Paragraph 18 of the Employee’s Pension Scheme, 1995)
            </p>
          </div>

          <Form.Group as={Row} controlId="name">
            <Form.Label column sm={3}>
              Name (in Block Letters)*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                placeholder="Name"
                type="text"
                name="name"
                disabled
                value={fullName.toUpperCase()}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group className="row-with-mb-zero-label-pt-zero" as={Row}>
            <Form.Label column sm={3}>
              Father’s/Mother's/Spouse’s Name*
            </Form.Label>
            <Col sm={4}>
              <div>
                <Form.Check
                  id="father-relation"
                  inline
                  label="Father"
                  name="gratuityIsFatherOrMotherOrSpouse"
                  onChange={handleOnChangePersonalDetails}
                  required
                  checked={gratuityIsFatherOrMotherOrSpouse == 1}
                  type="radio"
                  value="1"
                />
                <Form.Check
                  id="mother-relation"
                  inline
                  label="Mother"
                  name="gratuityIsFatherOrMotherOrSpouse"
                  checked={gratuityIsFatherOrMotherOrSpouse == 2}
                  onChange={handleOnChangePersonalDetails}
                  required
                  type="radio"
                  value="2"
                />
                <Form.Check
                  id="spouse-relation"
                  inline
                  label="Spouse"
                  name="gratuityIsFatherOrMotherOrSpouse"
                  checked={gratuityIsFatherOrMotherOrSpouse == 3}
                  onChange={handleOnChangePersonalDetails}
                  required
                  disabled={!getFatherOrMotherOrSpouseName(
                    3,
                    familyMembers
                  )}
                  type="radio"
                  value="3"
                />
              </div>
            </Col>
            <Col sm={5} />
          </Form.Group>
          <Form.Group as={Row} controlId="fatherOrMotherOrSpouseName">
            <Col sm={3} />
            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                disabled
                placeholder="Father’s/Mother's/Spouse’s Name"
                type="text"
                value={getFatherOrMotherOrSpouseName(
                  gratuityIsFatherOrMotherOrSpouse,
                  familyMembers
                )}
                onChange={handleOnChangePersonalDetails}
                name="epfForm2FatherOrSpouseOrMotherName"
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="dateofbirth">
            <Form.Label column sm={3}>
              Date of birth*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                disabled
                name="dob"
                required
                size="sm"
                type="text"
                value={getFormattedDate(personalDetails.birthDate)}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="sex">
            <Form.Label column sm={3}>
              Sex*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                disabled
                size="sm"
                required
                type="text"
                name="sex"
                value={getGenderName(personalDetails.gender, genders)}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="maritalStatus">
            <Form.Label column sm={3}>
              Marital Status*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                disabled
                size="sm"
                required
                type="text"
                name="isMarried"
                value={getMaritalName(
                  personalDetails.maritalStatus,
                  maritalStatusList
                )}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="permanentAddress">
            <Form.Label column sm={3}>
              Permanent Address*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                placeholder="Permanent Address"
                as="textarea"
                rows={3}
                name="permanentAddress"
                disabled
                value={getAddressAsString(
                  ADDRESS_TYPES.PERMANENT,
                  addresses,
                  states
                )}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="temporaryAddress">
            <Form.Label column sm={3}>
              Temporary Address*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                size="sm"
                required
                placeholder="Temporary Address"
                rows={3}
                as="textarea"
                name="temporaryAddress"
                disabled
                value={getAddressAsString(
                  ADDRESS_TYPES.CURRENT,
                  addresses,
                  states
                )}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>

          <Form.Group as={Row} controlId="dateofJoining">
            <Form.Label column sm={3}>
              Date of Joining*
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                disabled
                name="dateofJoining"
                required
                size="sm"
                type="text"
                value={getFormattedDate(dateofJoining)}
              />
            </Col>
            <Col sm={5} />
          </Form.Group>
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header>PART – A (EPF)</Card.Header>
        <Card.Body>
          <p>
            I hereby nominate the person(s)/cancel the nomination made by me
            previously and nominate the person(s) mentioned below to receive the
            amount standing to my credit in the Employee’s Provident Fund, in
            the event of Death.
          </p>

          <GratuityNominees
            familyMembers={familyMembers}
            relationShipList={relationShipList}
            gratuityNomination={ePFNomineeDetails}
            handleOnSelectedNominee={handleOnSelectedNominee}
            handleOnDeleteNominee={handleOnDeleteNominee}
            handleOnChangeGratuityDetails={handleOnChangeGratuityDetails}
            isEPFForm2={true}
          />
          <ol>
            <li>
              Certified that I have no family as defined in para 2(g) of the
              Employees’ Provident Fund Scheme, 1952 and should I acquire a
              family hereafter the above nomination should be deemed or
              cancelled.
            </li>
            <li>Certified that my father/mother is/are dependent upon me.</li>
          </ol>
          <Row>
            <Col sm={7}></Col>
            <Col sm={5}>
              <Form.Control
                size="sm"
                required
                type="text"
                disabled
                name="signature"
                placeholder="Signature or Thumb Impression of the Subscriber"
                value={fullName}
              />
              <Form.Label>
                Signature or Thumb Impression of the Subscriber*
              </Form.Label>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  );
};

export default EPFForm2;
